export const ordersRouteNames = {
  orders: 'orders-v2-new',
  orderDetails: 'order-details-v2-new',
}
